import { inject, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from '@core/services/config.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private readonly appConfigService = inject(AppConfigService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.appConfigService.currentConfig() && request.url.includes('vivenu')) {
      request = this.addTokenToRequest(request);
    }

    return next.handle(request);
  }

  private addTokenToRequest(request: HttpRequest<unknown>) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${this.appConfigService.currentConfig().tokenKey}`
      }
    });
  }
}
